const ACCENTS = {
  teal: { ring: "bg-cass-teal/15 text-cass-teal", bar: "bg-cass-teal" },
  orange: { ring: "bg-orange-100 text-orange-500", bar: "bg-orange-400" },
  sky: { ring: "bg-sky-100 text-sky-600", bar: "bg-sky-500" },
  violet: { ring: "bg-violet-100 text-violet-600", bar: "bg-violet-500" },
  fuchsia: { ring: "bg-fuchsia-100 text-fuchsia-600", bar: "bg-fuchsia-500" },
  indigo: { ring: "bg-indigo-100 text-indigo-600", bar: "bg-indigo-500" },
  amber: { ring: "bg-amber-100 text-amber-600", bar: "bg-amber-500" },
  rose: { ring: "bg-rose-100 text-rose-600", bar: "bg-rose-500" },
  emerald: { ring: "bg-emerald-100 text-emerald-600", bar: "bg-emerald-500" },
  navy: { ring: "bg-cass-navy/10 text-cass-navy", bar: "bg-cass-navy" },
};

export default function PageHeader({ title, subtitle, actions, Icon, accent }) {
  const a = ACCENTS[accent];
  return (
    <div className="relative flex flex-col sm:flex-row sm:items-start justify-between gap-4 px-4 md:px-8 py-4 md:py-6 border-b border-border bg-white/70 backdrop-blur-xl sticky top-0 z-20">
      {a && <span className={`absolute left-0 top-0 bottom-0 w-1.5 ${a.bar}`} />}
      <div className="flex items-center gap-3">
        {a && Icon && <span className={`w-11 h-11 rounded-xl grid place-items-center shrink-0 ${a.ring}`}><Icon className="w-5 h-5" /></span>}
        <div>
          <h1 className="font-alt text-2xl font-bold text-cass-navy tracking-tight">{title}</h1>
          {subtitle && <div className="text-sm text-cass-slate mt-0.5">{subtitle}</div>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:justify-end">{actions}</div>}
    </div>
  );
}
